import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enTranslations from './languajes/en.json';
import esTranslations from './languajes/es.json';

const resources = {
  en: {
    translation: enTranslations,
  },
  es: {
    translation: esTranslations,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    supportedLngs: ['en', 'es'],
    fallbackLng: 'es',
    debug: true,
    detection: {
      order: ['localStorage', 'queryString', 'cookie', 'sessionStorage', 'navigator', 'htmlTag'],
      caches: ['cookie', 'localStorage'],
      lookupLocalStorage: 'logged_user_language',
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
